type CurrencyType = '₹' | '$' | '€';

export const currency: CurrencyType = '$';

export const currentYear = new Date().getFullYear();

export const appName = 'Reazly';
export const appTitle = 'Reazly - Smart MindMaps';
export const appDescription: string = '';

export const author: string = 'Webora';
export const authorWebsite: string = '';
export const authorContact: string = '';

export const basePath: string = '';
